import * as React from 'react';

import { CSS_THREE_LINES_HEIGHT, useDescriptionLines } from './hooks/useDescriptionLines';
import { Description } from '../../components/MapOfferCard/Description';

interface IMapOfferCardDescriptionContainer {
  description: string;
}

export const MapOfferCardDescriptionContainer: React.FC<IMapOfferCardDescriptionContainer> = ({ description }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const [isNeedReadMore, setNeedReadMore] = React.useState(false);
  const [descriptionHeight, setDescriptionHeight] = React.useState<number | string>(CSS_THREE_LINES_HEIGHT);

  const descriptionRef = React.useRef<HTMLDivElement | null>(null);

  useDescriptionLines({ descriptionRef, setDescriptionHeight, isExpanded, setNeedReadMore });

  const handleReadMoreClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <Description
      isExpanded={isExpanded}
      isNeedReadMore={isNeedReadMore}
      description={description}
      descriptionRef={descriptionRef}
      onClick={handleReadMoreClick}
      maxHeight={descriptionHeight}
    />
  );
};
